module.exports = __webpack_public_path__ + "static/media/search.64b17ba0.svg";